import { Link } from '@tanstack/react-router'
import type { MemberLesson } from '../api/member-access.contract'
import {
  curriculum,
  lessonIndex,
  lessonLink,
  lessonMeta,
  lessonTitle,
  moduleCard,
  moduleCount,
  railModule,
  moduleHead,
  moduleTitle,
  rail,
} from './member-access.css'

type TreeLesson = Pick<MemberLesson['lesson'], 'id' | 'title' | 'kind' | 'locked' | 'availableAt' | 'completed'>

type MemberCourseTreeProps = {
  producerId?: string
  productId: string
  preview?: boolean
  placement?: 'page' | 'rail'
  currentLessonId?: string
  modules: readonly { id: string; title: string; lessons: readonly TreeLesson[] }[]
}

const kindLabels: Record<TreeLesson['kind'], string> = {
  text: 'Texto',
  pdf: 'PDF',
  video: 'Vídeo',
}

function formatAvailableAt(value: string) {
  const date = new Date(value)
  return `${String(date.getUTCDate()).padStart(2, '0')}/${String(date.getUTCMonth() + 1).padStart(2, '0')}`
}

function lessonStatus(lesson: TreeLesson) {
  if (lesson.locked) {
    return `Disponivel em ${lesson.availableAt ? formatAvailableAt(lesson.availableAt) : ''}`
  }
  if (lesson.completed) return 'Concluída'
  return kindLabels[lesson.kind]
}

function TreeList({
  producerId,
  productId,
  preview,
  placement,
  currentLessonId,
  modules,
}: MemberCourseTreeProps) {
  return (
    <>
      {modules.map((module) => (
        <section key={module.id} className={placement === 'rail' ? railModule : moduleCard} aria-label={module.title}>
          <header className={moduleHead}>
            <h2 className={moduleTitle}>{module.title}</h2>
            <span className={moduleCount}>
              {module.lessons.length} {module.lessons.length === 1 ? 'aula' : 'aulas'}
            </span>
          </header>
          <div>
            {module.lessons.map((lesson, index) => {
              const state = lesson.locked
                ? 'locked'
                : lesson.id === currentLessonId
                  ? 'current'
                  : 'idle'
              const body = (
                <>
                  <span className={lessonIndex}>{String(index + 1).padStart(2, '0')}</span>
                  <span className={lessonTitle}>{lesson.title}</span>
                  <span className={lessonMeta}>{lessonStatus(lesson)}</span>
                </>
              )
              if (lesson.locked) {
                return (
                  <div key={lesson.id} className={lessonLink({ state })}>
                    {body}
                  </div>
                )
              }
              if (preview) {
                return (
                  <Link
                    key={lesson.id}
                    className={lessonLink({ state })}
                    to="/area-membros/preview/$productId/aulas/$lessonId"
                    params={{ productId, lessonId: lesson.id }}
                  >
                    {body}
                  </Link>
                )
              }
              return (
                <Link
                  key={lesson.id}
                  className={lessonLink({ state })}
                  to="/acesso/$producerId/cursos/$productId/aulas/$lessonId"
                  params={{ producerId: producerId ?? '', productId, lessonId: lesson.id }}
                >
                  {body}
                </Link>
              )
            })}
          </div>
        </section>
      ))}
    </>
  )
}

export function MemberCourseTree(props: MemberCourseTreeProps) {
  return (
    <aside className={props.placement === 'rail' ? rail : curriculum} aria-label="Aulas do curso">
      <TreeList {...props} />
    </aside>
  )
}
